$(document).ready(function() {
    var DOC = $(document);

    $(document).on('ajaxSuccess', function() {
        var games__count,
            games = $('[data-random]'),
            games_container = games.find('.wheel-with-games');

        DOC.on('click', '[data-random-next]', function () {
            $(this).addClass('games-random--pressed');

            games_container.map(function (key, item) {
                $(item).slotMachine().shuffle(5);
            });

            setTimeout(function(){
                $('[data-random-next]').removeClass('games-random--pressed');
            }, 3000);
        });

        games_container.map(function (key, item) {
            $(item).slotMachine({
                delay: Math.floor(Math.random() * (500 - 300 + 100) + 300),
                randomize: function () {
                    return games__count;
                }
            });
        });
    });
    $(window).on('resize', function(){
        $('.roll__list').each(function(){
            var offset = parseInt($(this).css('transform').split(',')[5]), //берем текущее смещение блока
                height = $(this).find('> li:first-of-type').height(), //высота блока
                i = Math.round(Math.abs(offset / height)), // считаем сколько раз сместился блок
                s = height * i;

            $(this).css('transform', 'matrix(1, 0, 0, 1, 0, -'+ s +')')
        });
    });
});
